import { ActionTypes } from '../../../constants';

export const selectThematicSelection = (thematicSelection: string) => {
  return {
    type: ActionTypes.SELECT_THEMATIC_SELECTION,
    thematicSelection,
  };
};
